/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.

 *  */

/** Configuration dela viriable globale , L'objet window représente une fenêtre contenant un document DOM   */
const API_URL = 'env'; // API_BATCHTIME ; ; API_STATICS

/**
 * authenticateUser : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function authenticate
 * @param { any } user
 * @return  { Promise }
 * @method 'POST'
 */
export const authenticateUser = (user: any) => {
    const URL_DAI: any = window[API_URL].API_URL_STATIC;
    const API_BATCH = URL_DAI + '/authenticate';

    return fetch(API_BATCH, {
        body: JSON.stringify({
            'password': String(user.password),
            'rememberMe': false,
            'username': String(user.identifiant),
        }),

        cache: 'default',

        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },

        method: 'POST',
        // mode: 'cors',
    });
};

/**
 * delayedTimes : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function delayedTimes
 * @param {}
 * @return  { Promise }
 * @method 'POST'
 */
export const delayedTimes = (index: number) => {
    const URL_DAI: any = window[API_URL].API_BATCHTIME;
    const API_BATCH = URL_DAI;
    return fetch(API_BATCH, {
        body: JSON.stringify({"_from": index*3 ,"_to": 10*(Number(index))}),
        cache: 'default',
        
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },

        method: 'POST',
    });
};


/**
 * realTimes : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function realTimes
 * @param {}
 * @return  { Promise }
 * @method 'POST'
 */
export const realTimes = () => {
    const URL_DAI: any = window[API_URL].API_REALTIME;
    const API_BATCH = URL_DAI;
    return fetch(API_BATCH, {
        body: JSON.stringify({"_from": 0 ,"_to": 5}),
        cache: 'default',

        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },

        method: 'POST',
    });
};



/**
 * Stats : Manipulation ( appel ou MAJ) des données avec l'API Fetch,
 * @function Stats
 * @param {}
 * @return  { Promise }
 * @method 'POST'
 */
export const Stats = () => {
    const URL_DAI: any = window[API_URL].API_STATICS;
    const API_BATCH = URL_DAI;
    return fetch(API_BATCH, {
        body: JSON.stringify({}),
        cache: 'default',

        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },

        method: 'POST',
    });
};


// WEBPACK FOOTER //
// ./src/root/utils/server/index.ts